//fill your code
// Actions:

// const addToCart = (dispatch, product) => {
//     dispatch({
//         type: "ADD_TO_CART",
//         item: product
//     })

//     dispatch({
//         type: "REDUCE_QUANTITY",
//         item: product
//     })

// }


// const removeFromCart = (dispatch, product) => {
//     dispatch({
//         type: "REMOVE_FROM_CART",
//         item: product
//     })
// }




// ------------------------------------------------------------------------

// Another Implementation:

const reduceQuantity = (product) => {
    return {
        type: "REDUCE_QUANTITY",
        item: {
            name: product.productName,
            price: product.price,
            id: product.id,
            quantity: 1
        }
    }
}


const addToCart = (product) => {

    return {
        type: "ADD_TO_CART",
        item: {
            name: product.productName,
            price: product.price,
            id: product.id,
            quantity: 1
        }
    }
}


const removeFromCart = (product) => {
    return {
        type: "REMOVE_FROM_CART",
        item: product
    }
}








export {addToCart, removeFromCart, reduceQuantity}
